<template>
  <div>
    <div ref="zhibo" class="item" @click="handleItemClick(src, 0)">
      <div>
        <img class="image" :src="require('@/assets/live-icon0.png')" />
        <span :class="playing === 0 ? 'name-playing' : 'name'">
          <!-- {{ name }} -->
          直播
        </span>
      </div>

      <div v-if="playing === 0" class="playing">
        <span class="playing-bar playing-bar1"></span>
        <span class="playing-bar playing-bar2"></span>
        <span class="playing-bar playing-bar3"></span>
      </div>
    </div>

    <div v-if="videoList.length > 0">
      <div
        class="item"
        v-for="(item, index) in videoList"
        :key="item.liveId"
        @click="handleItemClick(item, index + 1)"
      >
        <div>
          <img class="image" :src="require('@/assets/live-icon.png')" />
          <span :class="playing === index + 1 ? 'name-playing' : 'name'">
            {{ `回看片段${index + 1}` }}
          </span>
        </div>

        <div v-if="playing === index + 1" class="playing">
          <span class="playing-bar playing-bar1"></span>
          <span class="playing-bar playing-bar2"></span>
          <span class="playing-bar playing-bar3"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoList',
  props: {
    videoList: {
      type: Array,
      required: true,
      default: () => []
    },
    src: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '课程'
    },
    playing: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$refs.zhibo.click();
  },
  methods: {
    handleItemClick(item, index) {
      if (this.playing !== index) {
        // this.playing = index;
        this.$emit('playVideo', { url: item.videoUrl, index: index });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 16px 0;
  border-bottom: 1px solid #ededed;

  > div {
    display: flex;
  }

  .image {
    width: 16px;
    height: 16px;
    margin: 2px 15px;
  }

  .name {
    color: #333;
    font-size: 0.32rem;
    text-align: left;
    line-height: 24px;
    margin-right: 15px;
  }

  .name-playing {
    // color: rgb(245, 179, 14);
    color: #1890ff;
    font-size: 0.32rem;
    text-align: left;
    line-height: 24px;
  }

  .playing {
    width: 15px;
    height: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    box-sizing: border-box;
    margin-top: -3px;
    margin-right: 35px;

    @keyframes up-and-down {
      10% {
        height: 30%;
      }
      30% {
        height: 100%;
      }
      60% {
        height: 50%;
      }
      80% {
        height: 75%;
      }
      100% {
        height: 20%;
      }
    }

    .playing-bar {
      display: inline-block;
      background-color: #1890ff;
      // background-color: rgb(245, 179, 14);
      width: 3px;
      height: 100%;
      animation: up-and-down 1.3s ease infinite alternate;
    }

    .playing-bar1 {
      height: 60%;
    }

    .playing-bar2 {
      height: 30%;
      animation-delay: -2.4s;
    }

    .playing-bar3 {
      height: 75%;
      animation-delay: -3.7s;
    }
  }
}
</style>
